module.exports = __webpack_public_path__ + "static/panasonic-logo-6c0ebf3615c71bd6e8c484c621556c59.png";